export const contentTableConfig = {
  title: '',
  // title: ('common.app-terminal-online-list'),
  propList: [
    {
      prop: 'extend1',
      label: 'param.template-name'
    },
    {
      prop: 'extend2',
      label: 'menu.template-group'
    },
    {
      prop: 'successCount',
      label: 'monitor.success-count'
    },
    {
      prop: 'failedCount',
      label: 'monitor.failed-count'
    },
    {
      prop: 'pushedCount',
      label: 'monitor.pushed-count'
    },
    {
      prop: 'updatedBy',
      label: 'general.operator'
    },
    {
      prop: 'createdTime',
      label: 'general.operation-time',
      width: 160,
      slotName: 'formatZeroTime'
    },
    {
      label: 'common.app-operation',
      width: 105,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true,
  showSelectColumn: false
}
